module.exports = __webpack_public_path__ + "static/media/adb_1.bf62e3b0.png";